import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import NdsGlobalStyle from './NdsGlobalStyle';
function NdsThemeProviderBaseHoc(defaultTheme) {
    function NdsThemeProvider(props) {
        const { theme, children } = props;
        return (React.createElement(ThemeProvider, { theme: theme },
            React.createElement(React.Fragment, null,
                React.createElement(NdsGlobalStyle, null),
                children)));
    }
    NdsThemeProvider.propTypes = {
        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
        theme: PropTypes.oneOfType([PropTypes.object])
    };
    NdsThemeProvider.defaultProps = {
        children: null,
        theme: defaultTheme
    };
    return NdsThemeProvider;
}
export default NdsThemeProviderBaseHoc;
//# sourceMappingURL=NdsThemeProviderBaseHoc.js.map